var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#7FCC26"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3773_17029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 17,
    width: 40,
    height: 41
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17.5,
    width: 40,
    height: 40,
    fill: "#FF1313"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3773_17029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.65 47C26.2017 47 25.8147 46.845 25.4891 46.5349C25.163 46.2248 25 45.8499 25 45.4102C25 44.9701 25.1579 44.5899 25.4737 44.2698C25.7896 43.9501 26.1816 43.7902 26.65 43.7902C27.0983 43.7902 27.4801 43.9501 27.7955 44.2698C28.1113 44.5899 28.2692 44.9701 28.2692 45.4102C28.2692 45.8499 28.1113 46.2248 27.7955 46.5349C27.4801 46.845 27.0983 47 26.65 47ZM31.1109 46.4002V44.39H47V46.4002H31.1109ZM26.65 39.5898C26.2017 39.5898 25.8147 39.4347 25.4891 39.1246C25.163 38.815 25 38.4402 25 38C25 37.5598 25.1579 37.185 25.4737 36.8754C25.7896 36.5653 26.1816 36.4102 26.65 36.4102C27.0983 36.4102 27.4801 36.5653 27.7955 36.8754C28.1113 37.185 28.2692 37.5598 28.2692 38C28.2692 38.4402 28.1113 38.815 27.7955 39.1246C27.4801 39.4347 27.0983 39.5898 26.65 39.5898ZM31.1109 38.99V37.01H47V38.99H31.1109ZM26.6192 32.2098C26.1714 32.2098 25.7896 32.055 25.4737 31.7454C25.1579 31.4353 25 31.0501 25 30.5898C25 30.1501 25.1579 29.7752 25.4737 29.4651C25.7896 29.155 26.1714 29 26.6192 29C27.088 29 27.4801 29.155 27.7955 29.4651C28.1113 29.7752 28.2692 30.1501 28.2692 30.5898C28.2692 31.0501 28.1113 31.4353 27.7955 31.7454C27.4801 32.055 27.088 32.2098 26.6192 32.2098ZM31.1109 31.61V29.5998H47V31.61H31.1109Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity-icon.0703eb8b45f0d53ad0121f965ebd5dbd.svg";
export { ForwardRef as ReactComponent };